import React, { useEffect, useState } from "react";
import axios from "./axios";
import './row.css';
import YouTube from 'react-youtube';
import movieTrailer from 'movie-trailer';

const baseurl = "https://image.tmdb.org/t/p/original/";

const Row = ({ title, fetchUrl,isLargeRow }) => {
  const [movies, setmovies] = useState([]);
  const [trailerUrl,settrailerUrl]=useState("");


  useEffect(() => {
    async function fetchData() {
      const request = await axios.get(fetchUrl);
      setmovies(request.data.results);

      return request;
    }
    fetchData();
  }, [fetchUrl]); //[]run once when the row loads dont run again

  const opts={
    height:"390px",
    width:"100%",
    playerVars:{
      autoplay:1,
    },
  };

  const handleClick=(movie)=>{
   
      if(trailerUrl){
        settrailerUrl('');
      }else{
        movieTrailer(movie?.title || movie?.name || movie?.original_name || movie?.original_title).then((url)=>{
                const urlParams=new URLSearchParams(new URL(url).search);
               settrailerUrl(urlParams.get('v')); 
        }).catch((err)=>console.log(err));
      }
  }
  
  return (
    <>
      <div className="row">
        <h2>{title}</h2>
        <div className="row_posters">
          {movies.map((movie) => (
            <img
            
             key={movie.id}
             onClick={()=> handleClick(movie)}
              className={`row_poster ${isLargeRow && "row_posterLarge"}` }
              src={`${baseurl}${isLargeRow? movie.poster_path:movie.backdrop_path}`}
              alt={movie.name}
            />
          ))}
        </div>
   {trailerUrl && <YouTube videoId={trailerUrl} opts={opts}/>}
      </div>
    </>
  );
};

export default Row;
